export const isSafari = () => {
    return (
        typeof window !== 'undefined' && /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
    );
};
